<template>
    <div class="companyProfile">
        <div class="rent_content" v-if="isEmptyData" v-html="replaceHtml(profileContent)"></div>
        <div style='width: 100%;text-align: center;margin: 75px 0 ;' v-else><img
                src='../../assets/images/no_page.png' alt='没有数据' width="160"></div>
    </div>
</template>

<script>
export default {
  name: "companyProfile",
  inject: ["replaceHtml"],
  data: function() {
    return {
      isEmptyData: true,
      profileContent: ""
    };
  },
  created() {
    this.GetCompanyProfile();
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[4]");
  },
  methods: {
    GetCompanyProfile() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/other/getIntro",
        dataType: "json",
        data: {
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result.content) {
              this.isEmptyData = true;
              this.profileContent = res.data.result.content;
            } else {
              this.isEmptyData = false;
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
.companyProfile {
  @media (min-width: 410px) {
    min-height: 527px;
  }
  @media (max-width: 375px) {
    min-height: 463px;
  }
  @media (max-width: 360px) {
    min-height: 426px;
  }
  @media (max-width: 320px) {
    min-height: 348px;
  }
}
</style>
<style scoped>
.rent_content {
  padding: 10px 20px;
}
.rent_content >>> img {
  width: 100%;
  vertical-align: bottom;
}
</style>
